import type { ProductMetricsDto } from 'entities/ReportSavingsSummary';
import type { TFunction } from 'i18next';

export function getPropertiesDisplayLabel(
    dto: ProductMetricsDto,
    t: TFunction,
): string {
    const properties = dto.properties ?? [];

    if (dto.propertyCount === 1 && properties.length === 1) {
        return properties[0].propertyName ?? t('savingsSummary.noValue');
    }

    if (dto.propertyCount > 0) {
        if (dto.propertyCount === 1) {
            return t('savingsSummary.propertiesCountOne');
        }

        return t('savingsSummary.propertiesCountOther', {
            count: dto.propertyCount,
        });
    }

    return t('savingsSummary.noValue');
}

export function getPropertiesTooltip(dto: ProductMetricsDto): string | null {
    if (!dto.properties || dto.properties.length <= 1) {
        return null;
    }

    const names = dto.properties
        .map((p) => p.propertyName)
        .filter((name): name is string => Boolean(name?.trim()))
        .sort((a, b) =>
            a.localeCompare(b, undefined, {
                sensitivity: 'base',
            }),
        );

    if (!names.length) {
        return null;
    }

    return names.join('\n');
}
